
import Article from "./Article"
import EnergyVoteCard from "./EnergyVoteCard"
import AppButton from "./AppButton"
import NavButton from "./NavButton"
import stubDirectives from "../mixins/stubDirectives"

export default {
  name: `EnergyVoteLayout`,
  components: {
    Article,
    EnergyVoteCard,
    AppButton,
    NavButton
  },
  mixins: [stubDirectives],
  props: {
    theme: {
      required: true,
      type: String
    },
    title: {
      required: true,
      type: Array
    },
    description: {
      type: Array,
      default: () => []
    },
    selectionText: {
      type: Array,
      default: () => []
    },
    cards: {
      required: true,
      type: Array
    },
    button: {
      type: Array,
      default: () => []
    },
    disclaimer: {
      type: Array,
      default: () => []
    },
    voteTracking: {
      type: Array,
      default: null
    },
    energyVote: {
      type: String,
      default: null
    },
    voteEnabled: {
      type: Boolean,
      default: false
    },
    isCardOrderRandom: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    titleData() {
      return this.title[0] && this.title[0].textContent
        ? this.title[0].textContent
        : {}
    },
    descriptionData() {
      return this.description[0] && this.description[0].textContent
        ? this.description[0].textContent
        : {}
    },
    selectionTextData() {
      return this.selectionText[0] && this.selectionText[0].textContent
        ? this.selectionText[0].textContent
        : {}
    },
    disclaimerData() {
      return this.disclaimer[0] && this.disclaimer[0].textContent
        ? this.disclaimer[0].textContent
        : {}
    },
    buttonData() {
      return this.button[0] ? this.button[0] : {}
    },
    cardsData() {
      if (this.isCardOrderRandom) {
        this.shuffle(this.cards)
      }
      return this.cards
    }
  },
  methods: {
    shuffle(array) {
      // Source: Fisher-Yates shuffle
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1))
        ;[array[i], array[j]] = [array[j], array[i]]
      }
    }
  }
}
